import Reveal from '@/components/base/Reveal';

const hiringAreas = [
  'Restaurant Management',
  'Front of House',
  'Back of House',
  'Culinary',
  'Hospitality & Guest Experience',
  'Corporate / Support Roles',
];

export default function Careers() {
  return (
    <section id="careers" className="py-24 md:py-32 px-6 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.35em] text-primary-600">Careers</p>
          <h2 className="font-heading text-3xl md:text-5xl mt-6 text-foreground-950 leading-[1.1]">
            Good restaurants start with great people.
          </h2>
          <p className="mt-7 text-foreground-700 leading-relaxed">
            Our restaurants are built by people who care about hospitality, teamwork, quality, and creating memorable
            experiences for guests.
          </p>
          <p className="mt-4 text-foreground-700 leading-relaxed">
            We&apos;re always interested in connecting with talented people who want to grow with a restaurant group
            and contribute to great hospitality.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <a
              href="#contact"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-foreground-950 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors"
            >
              Join Our Team
            </a>
            <a
              href="#contact"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md border border-foreground-300 text-foreground-900 text-sm font-medium hover:bg-background-100 transition-colors"
            >
              Ask About Opportunities
            </a>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="bg-background-100 border border-background-200 p-8 md:p-10">
            <p className="text-xs uppercase tracking-[0.25em] text-foreground-500">We hire across</p>
            <ul className="mt-6 space-y-0 divide-y divide-background-200">
              {hiringAreas.map((area) => (
                <li key={area} className="flex items-center justify-between py-3.5">
                  <span className="text-foreground-800">{area}</span>
                  <span className="w-5 h-5 flex items-center justify-center text-primary-600">
                    <i className="ri-arrow-right-line text-base"></i>
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  );
}